<template>
	<CardEmail v-if="isEmail()" :emailURI="resource.uri" />
	<CardPublicReport
		v-else-if="isPublicReport()"
		:reportURI="resource.uri"
		:transferredFrom="transferredFrom"
		@viewImage="openPhotoViewer"
	/>
	<CardVirtualInspection
		v-else-if="isVirtualInspection()"
		:inspectionURI="resource.uri"
		@viewImage="openPhotoViewer"
	/>
	<CardText v-else-if="isText()" :textURI="resource.uri" />
	<CardMessage v-else-if="isMessage()" :message="resourceAsMessage(resource)" />
	<p v-else>Unrecognized resource {{ resource.type }}</p>
</template>
<script setup lang="ts">
import { Message, ResourceStub } from "@/type/api";
import CardEmail from "@/components/CardEmail.vue";
import CardMessage from "@/components/CardMessage.vue";
import CardPublicReport from "@/components/CardPublicReport.vue";
import CardText from "@/components/CardText.vue";
import CardVirtualInspection from "@/components/CardVirtualInspection.vue";

interface Emits {
	(e: "viewImage", uuid: string): void;
}
interface Props {
	resource: ResourceStub;
	transferredFrom?: string | null;
}
const emit = defineEmits<Emits>();
const props = defineProps<Props>();
function isEmail(): boolean {
	return props.resource.type == "email";
}
function isMessage(): boolean {
	return props.resource.type == "message";
}
function isPublicReport(): boolean {
	return props.resource.type.startsWith("publicreport.");
}
function isText(): boolean {
	return props.resource.type == "text";
}
function isVirtualInspection(): boolean {
	return props.resource.type == "virtual-inspection";
}
function openPhotoViewer(uuid: string) {
	emit("viewImage", uuid);
}
function resourceAsMessage(stub: ResourceStub): Message {
	const res = stub as unknown as Message;
	return new Message({
		content: res.content,
		created: res.created,
		destination: res.destination,
		source: res.source,
		type: res.type,
	});
}
</script>
